module.exports = __webpack_public_path__ + "ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ca.svg
// module id = 478
// module chunks = 0